import { config } from "../config/environment";

export default async function requestHandler({ path, method, body, params }) {
  const apiUrl = config.api.baseUrl;
  const sessionId = localStorage.getItem("sessionId");

  if (!sessionId) {
    return {
      success: false,
      data: null,
      error: "No session found",
    };
  }

  try {
    let url = `${apiUrl}/${path}`;

    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      if (queryParams) {
        url += `?${queryParams}`;
      }
    }

    const response = await fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionId}`,
      },
      body: JSON.stringify(body),
    });

    // Handle expired/invalid session tokens centrally
    if (response.status === 401) {
      localStorage.removeItem('sessionId');
      window.location.href = '/unauthorized';
      return { success: false, data: null, error: 'Session expired' };
    }

    // Check for errors
    if (!response.ok) {
      const jsonResponse = await response.json();
      return {
        success: false,
        data: null,
        error: jsonResponse.error || jsonResponse.message || "Request failed",
      };
    }

    // Auto-detect response type via Content-Type header
    const contentType = response.headers.get("Content-Type") || "";

    if (contentType.includes("application/pdf")) {
      return {
        success: true,
        data: await response.blob(),
        error: null,
      };
    }

    // Default: parse as JSON
    const jsonResponse = await response.json();
    return {
      success: jsonResponse.success || false,
      data: jsonResponse.data || null,
      error: jsonResponse.error || jsonResponse.message || null,
    };
  } catch (error) {
    console.error("Error fetching data:", error);

    // When the backend redirects expired-token requests (e.g. to /api/login)
    // without CORS headers, fetch throws a TypeError (message varies: Chrome
    // "Failed to fetch", Safari "Load failed", Firefox "NetworkError …").
    // Redirect to clear the stale session.
    if (error instanceof TypeError && localStorage.getItem("sessionId")) {
      localStorage.removeItem("sessionId");
      window.location.href = "/unauthorized";
      return { success: false, data: null, error: "Session expired" };
    }

    return {
      success: false,
      data: null,
      error: "Network error occurred",
    };
  }
}
